var imagesLoaded = require('imagesloaded');

var ImagesLoaded = {

    init: function(className) {

        $(className).each(function() {

			var self = this;

			imagesLoaded(className, function () {
				$(self).addClass('is-loaded');
			})
        })
    }
}

module.exports = ImagesLoaded;



// WEBPACK FOOTER //
// ./assets/src/js/modules/imagesLoaded.js